// Per-word overrides, checked before generic capitalization. Add odd carrier spellings here.
export const CARRIER_NAME_OVERRIDES: Record<string, string> = {
  uhc: 'UHC',
  bcbs: 'BCBS',
  hmo: 'HMO',
  ppo: 'PPO',
  hcsc: 'HCSC',
  cvs: 'CVS',
  aarp: 'AARP',
  mvp: 'MVP',
  hap: 'HAP',
  cdphp: 'CDPHP',
}

// Display name for a carrier slug. A word with its own case (UPMC, O'Neil) keeps it. CSV export keeps the raw slug.
export const carrierLabel = (slug: string): string =>
  slug
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((w) => CARRIER_NAME_OVERRIDES[w.toLowerCase()] ?? (w === w.toLowerCase() ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(' ')
